import useOptions from 'components/Options/OptionsContext/useOptions';
import useApi from '../../api/useApi';
import { useError } from '../../hooks/useError';

const useLanguagesApi = () => {
  const { api, createFilterParams } = useApi();
  const { enqueueErrorSnackbar } = useError();
  const { refetchOptions } = useOptions();

  const getLanguages = async (filters) => {
    try {
      const { data } = await api({
        url: `/settings/languages${createFilterParams(filters)}`,
        method: 'get'
      });
      return data;
    } catch (error) {
      enqueueErrorSnackbar(error);
    }
  };

  const createLanguage = async (fields) => {
    try {
      const { data } = await api({
        url: '/settings/languages',
        method: 'post',
        data: fields
      });
      refetchOptions();
      return data;
    } catch (error) {
      enqueueErrorSnackbar(error);
    }
  };

  const updateLanguage = async (id, fields) => {
    try {
      const { data } = await api({
        url: `/settings/languages/${id}`,
        method: 'put',
        data: fields
      });
      refetchOptions();
      return data;
    } catch (error) {
      enqueueErrorSnackbar(error);
    }
  };

  const deleteLanguage = async (id) => {
    try {
      const { data } = await api({
        url: `/settings/languages/${id}`,
        method: 'delete'
      });
      refetchOptions();
      return data;
    } catch (error) {
      enqueueErrorSnackbar(error);
    }
  };

  return { getLanguages, createLanguage, updateLanguage, deleteLanguage };
};

export default useLanguagesApi;
